import styled from 'styled-components';

import { colors } from 'theme/colors';

export const StyledError = styled.p`
  background-color: ${colors.ui.snackbar.error};
  color: ${({ theme }) => theme.palette.common.white};
  font-size: 1.2rem;
  line-height: 1.4rem;
  font-weight: bold;
`;
